import { GzCompanyListWebComponent } from './component/GzCompanyListWebComponent';
import { WEB_COMPONENT_GZ_COMPANY_LIST } from '../../webcomponents.constants';

export { GzCompanyListWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_COMPANY_LIST, GzCompanyListWebComponent);
